import React from 'react';
import styled from 'styled-components';

import { AccordionBanner } from 'src/payments/components/accordion-banner/accordion-banner';
import { CashBackDetails } from 'src/payments/components/cash-back-details';
import MultiDiscount from 'src/payments/components/pbb-incentive-banner/assets/multi-discount';
import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

type CashBackIncentiveBannerProps = {
  className?: string;
  headlineVariant: 'available' | 'selected';
  marginBottom?: string;
  paymentStepText?: string;
  value: ValidIncentiveValue;
};

export const CashBackIncentiveBanner = ({
  className,
  headlineVariant,
  marginBottom,
  paymentStepText,
  value,
}: CashBackIncentiveBannerProps): JSX.Element => {
  const headline =
    headlineVariant === 'selected' ? (
      <span>
        You're getting <strong>${value} cash back</strong> by checking out with <strong>Pay by Bank</strong>
      </span>
    ) : (
      <span>
        Get <strong>${value} cash back</strong> on your first order paid by bank. <u>Terms Apply.</u>
      </span>
    );

  return (
    <StyledAccordionBanner
      className={className}
      marginBottom={marginBottom}
      borderRadius='4px 4px 4px 4px'
      graphic={<MultiDiscount amount={value} />}
      mainContent={headline}
      toggleContent={<CashBackDetails value={value} paymentStepText={paymentStepText} />}
    />
  );
};

const StyledAccordionBanner = styled(AccordionBanner)`
  & > .MuiCollapse-container {
    border-top: 1px solid var(--dcm-cash-back-incentive-banner-border-color, #8fcfc0);
  }
`;
